'use client';

import { NoticeWithIcon, Spacing } from '~/components';
import { Typography, Button } from '@bgzt/ui';

import { Link } from '~/components/Link';

export default function RootNotFound() {
  return (
    <>
      <Spacing height={120} />
      <NoticeWithIcon iconType="error">
        <Spacing height={12} />
        <Typography variant="S1" color="gray-900" as="p">
          존재하지 않는 페이지입니다.
        </Typography>
        <Spacing height={20} />
        <Button variant="normalLine">
          <Link href={'/'}>홈으로 이동</Link>
        </Button>
      </NoticeWithIcon>
    </>
  );
}
